import React from 'react';

import { UiTypography } from '@/components/ui/Typography';
import { PHEON_SUPPORT_EMAIL, TERMS_LINK } from '@/constants';
import { StripeV2SubscriptionPrice } from '@/services/stripe/dto';

export const OneDayVIPPaymentDescription: React.FC<{
  selectedPlan: StripeV2SubscriptionPrice;
}> = ({ selectedPlan }) => {
  return (
    <>
      <UiTypography variant="label-small" color="neutral-white" align="center">
        This is a one-time payment for 24 hours of VIP access —{' '}
        <strong style={{ fontStyle: 'italic' }}>
          no subscription, no auto-renewal
        </strong>
        . You will be charged ${selectedPlan.price} after the payment
        confirmation. Payments are processed in USD, excluding taxes.
      </UiTypography>
      <UiTypography variant="label-small" color="neutral-white" align="center">
        To learn more, see our{' '}
        <a href={TERMS_LINK} target="_blank">
          Terms of Use
        </a>{' '}
        or contact us at{' '}
        <a href={`mailto:${PHEON_SUPPORT_EMAIL}`} target="_blank">
          {PHEON_SUPPORT_EMAIL}
        </a>
        .
      </UiTypography>
    </>
  );
};
